import React from "react";
import "./about.css";
import ani_img from "../../assets/bannerabout.jpg";

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="content">
        <div>
          <h1>Welcome to PreggyZone</h1>
          <hr />
        </div>
        <div>
          <h6>
            <span>At Preggyzone,</span> we understand that pregnancy is a unique
            and transformative experience. Our mission is to be your trusted
            guide and support system throughout every stage of your pregnancy.
          </h6>
          <h6>
            <span>We offer</span> a range of features designed to help you
            navigate pregnancy with confidence. From our Baby Kick Timer to
            count your baby’s movements, to our Contraction Timer for those
            final moments before labor, we’ve got you covered.
          </h6>
          <h6>
            <span>Additionally,</span> we provide mild workout suggestions to
            keep you active and comfortable throughout your pregnancy, along
            with many more features to guide you through each phase.
          </h6>
          <h6>
            <span>At PreggyZone,</span> we’re dedicated to making your pregnancy
            experience easier, more informed, and filled with joy. Explore our
            website today and discover how we can support you every step of the
            way.
          </h6>
        </div>
      </div>
      <div className="image-container">
        <img src={ani_img} alt="Pregnancy Support" className="image-animate" />
      </div>
    </div>
  );
};

export default AboutUs;
